import { Link } from "react-router-dom";
import Button from "../components/common/Button";

function NotFoundPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-100 px-6 dark:bg-slate-900">
      <div className="w-full max-w-md rounded-[2rem] border border-white/50 bg-white/90 p-8 text-center shadow-2xl shadow-slate-300/25 dark:border-slate-800 dark:bg-slate-900 dark:shadow-black/20">
        <p className="text-sm font-semibold uppercase tracking-[0.3em] text-cyan-600 dark:text-cyan-300">
          404 Error
        </p>
        <h1 className="mt-4 text-3xl font-bold text-slate-900 dark:text-white">Page not found</h1>
        <p className="mt-3 text-sm text-slate-600 dark:text-slate-300">
          The page you requested does not exist in this demo route structure.
        </p>
        <Link to="/dashboard" className="mt-6 inline-block">
          <Button>Back to dashboard</Button>
        </Link>
      </div>
    </div>
  );
}

export default NotFoundPage;
